module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCookiesModal),
      expression: "showCookiesModal"
    }],
    staticClass: "cookies-content"
  }, [_c('div', {
    staticClass: "container-fluid font-20 white padding-40"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-1 margin-bottom-20"
  }, [_vm._v("\n        Nós usamos cookies, para melhorar a experiência do usuário em nosso site. Você pode encontrar mais informações na nossa\n        "), _c('router-link', {
    staticClass: "white",
    attrs: {
      "to": {
        name: 'privacy_policy'
      },
      "target": "_blank"
    }
  }, [_vm._v("políticas de privacidade")]), _vm._v(".\n        "), _c('br'), _vm._v("\n        Clicando em Aceitar você está concordando com nossa politica de privacidade e com a utilização dos cookies e outras ferramentas necessárias para melhorar sua experiência.\n      ")], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.setCookie
    }
  }, [_vm._v("Aceitar")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dc710120!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/CookiesModal.vue
// module id = 326
// module chunks = 18